export const messages = {
  en: {
    resourceStore: {
      title: 'Resource Store',
      queryConditions: 'Query Conditions',
      resourceInfo: 'Resource Information',
      resourceId: 'Resource ID',
      resourceName: 'Resource Name',
      resourceCode: 'Resource Code',
      price: 'Price',
      stock: 'Stock',
      operations: 'Operations',
      edit: 'Edit',
      delete: 'Delete',
      addResource: 'Add Resource',
      search: 'Search',
      confirmDelete: 'Confirm Delete',
      deleteConfirmMessage: 'Are you sure to delete this resource?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      resourceNameRequired: 'Resource name is required',
      priceRequired: 'Price is required',
      priceFormatError: 'Invalid price format',
      descriptionMaxLength: 'Description cannot exceed 200 characters'
    }
  },
  zh: {
    resourceStore: {
      title: '物品管理',
      queryConditions: '查询条件',
      resourceInfo: '物品信息',
      resourceId: '物品ID',
      resourceName: '物品名称',
      resourceCode: '物品编码',
      price: '物品价格',
      stock: '物品库存',
      operations: '操作',
      edit: '修改',
      delete: '删除',
      addResource: '添加物品',
      search: '查询',
      confirmDelete: '确认删除',
      deleteConfirmMessage: '确定删除该物品吗？',
      cancel: '取消',
      confirm: '确认',
      resourceNameRequired: '物品名称不能为空',
      priceRequired: '物品价格不能为空',
      priceFormatError: '物品价格格式错误',
      descriptionMaxLength: '描述不能超过200个字符'
    }
  }
}